
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("d7MLS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $85ffa7b3b6f1709d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $85ffa7b3b6f1709d$export$2e2bcd8739ae039 = {
    'fabric.editor.headingLink.ascSortingLabel': 'ordre croissant',
    'fabric.editor.headingLink.copied': "Copi\xe9\xa0!",
    'fabric.editor.headingLink.copyAnchorLink': "Copier le lien vers l'en-t\xeate",
    'fabric.editor.headingLink.copyAriaLabel': 'Copier',
    'fabric.editor.headingLink.descSortingLabel': "ordre d\xe9croissant",
    'fabric.editor.headingLink.failedToCopy': 'Copie impossible',
    'fabric.editor.headingLink.noneSortingLabel': "N\xe9ant",
    'fabric.editor.inlineComment.marker.end': 'fin du commentaire contextuel',
    'fabric.editor.inlineComment.marker.start': "d\xe9but du commentaire contextuel"
};

});


//# sourceMappingURL=fr.42cce7ba.js.map
